// ===========================================================================
// Membership — Constantes del módulo.
//
// EN DESARROLLO: el módulo es DEV-ONLY mientras se define su alcance. El gate
// es el entorno, igual que PLAYGROUND_ENABLED y CODING_OPS_V2_ENABLED:
//   - `yarn start`  → NODE_ENV = "development"  → MEMBERSHIP_ENABLED = true
//   - `yarn build`  → NODE_ENV = "production"   → MEMBERSHIP_ENABLED = false
//
// En el bundle de producción ni la ruta ni la sección del sidebar se registran.
// Cuando el módulo pase a productivo: quitar el gate acá y en
// navigationConfig.js, y registrar su moduleKey en roleRoutePermissions.js.
// ===========================================================================

export const MEMBERSHIP_ENABLED = process.env.NODE_ENV === "development";

export const MEMBERSHIP_BASE_PATH = "/membership";
